import styled from 'styled-components';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';

import { Header as HeaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  flex: 1;
  max-width: 330px;
  padding: 15px;
  align-self: flex-start;
`;

export const Header = styled(HeaderLayoutComponent)`
  text-align: justify;
  margin-bottom: 0px;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  &&& :hover {
    cursor: pointer;
  }
`;

export const Checkbox = styled(SemanticCheckbox)`
  margin-bottom: 5px;

  &.ui.checkbox {
    label {
      color: ${(props) => props.theme.color.textLabel};
      margin-right: 10px;
    }
    input:focus~label {
      color: ${(props) => props.theme.color.textLabel};
    }
  }
`;
